<template>
  <div
    :style='styleObj'
    :draggable='isDraggable'
    @drag.stop='drag'
    @dragstart.stop='dragStart'
    @dragover.stop='dragOver'
    @dragenter.stop='dragEnter'
    @dragleave.stop='dragLeave'
    @drop.stop='drop'
    @dragend.stop='dragEnd'
    class='dnd-container'
  >
    <div
      :class='{"is-clicked": isClicked,"is-hover":isHover}'
      @click="toggle"
      @mouseover='mouseOver'
      @mouseout='mouseOut'
      @dblclick="changeType"
    >
      <div
        :style="{ 'padding-left': (this.depth - 1) * 24 + 'px' }"
        :id='model.id'
        class='treeNodeText'
      >
        <span :class="[isClicked ? 'nodeClicked' : '','vue-drag-node-icon']"></span>
        <span class='text'>{{model.name}}</span>
      </div>
    </div>
    <div
      class='treeMargin'
      v-show="open"
      v-if="isFolder"
    >
      <drag-node
        v-for="item2 in model.children"
        :allowDrag='allowDrag'
        :allowDrop='allowDrop'
        :depth='increaseDepth'
        :model="item2"
        :key='item2.id'
        :defaultText='defaultText'
        :disableDBClick='disableDBClick'
      >
      </drag-node>
    </div>
  </div>
</template>

<script>
import { findRoot, exchangeData } from './js/util'

let id = 1000
let fromData = null
let toData = null
let nodeClicked // Attention:재귀의 모든 구성 요소는 동일한 "최상위 범위"를 사용합니다 (이 단어는 정확하지 않을 수 있지만 그 의미입니다). 즉 : 위의 여러 let 변수를 공유하십시오. 이것은 현재 노드의 강조 표시를 달성하기위한 기초를 제공합니다.
let rootTree = null // vue-drag-tree구성 요소 참조

export default {
  name: 'DragNode',
  data () {
    return {
      open: false,
      isClicked: false, // 현재 노드가 클릭되었습니다.
      isHover: false, // 현재 노드 hover
      styleObj: {
        opacity: 1
      }
    }
  },
  props: {
    model: Object,
    allowDrag: {
      type: Function,
      default: () => true
    },
    allowDrop: {
      type: Function,
      default: () => true
    },
    defaultText: {
      // 노드가 추가 될 때 표시되는 기본 텍스트.
      type: String,
      default: 'New Node'
    },
    depth: {
      type: Number,
      default: 0
    },
    disableDBClick: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isFolder () {
      return this.model.children && this.model.children.length
    },
    increaseDepth () {
      return this.depth + 1
    },
    isDraggable () {
      return this.allowDrag(this.model, this)
    }
  },
  methods: {
    toggle () {
      if (this.isFolder) {
        this.open = !this.open
      }
      // vue-drag-tree의 부모 구성 요소에있는 메소드를 호출하여 현재 클릭 된 노드의 id 값을 전달합니다.
      // API: 바깥 세상에 열려있는 현재 클릭 된 노드에 대한 정보
      rootTree.emitCurNodeClicked(this.model, this)

      // 클릭되는 노드의 상태를 기록하십시오.
      this.isClicked = !this.isClicked

      // 사용자는 노드 강조 표시가 필요합니다.
      // 처음으로 현재 노드를 클릭하십시오. 현재 노드가 강조 표시되어 다른 노드를 다시 설정하는 스타일을 탐색합니다.
      if (nodeClicked !== this.model.id) {
        let treeParent = rootTree.$parent

        // 트래버스를 사용하여 모든 트리 구성 요소의 강조 스타일 다시 설정
        let nodeStack = [treeParent.$children[0]]
        while (nodeStack.length !== 0) {
          let item = nodeStack.shift()
          item.isClicked = false
          if (item.$children && item.$children.length > 0) {
            nodeStack = nodeStack.concat(item.$children)
          }
        }
        // 그런 다음 강조 표시 할 현재 노드의 스타일을 설정하십시오.
        this.isClicked = true

        // 노드를 현재 노드로 설정하십시오.
        nodeClicked = this.model.id
      }
    },

    changeType () {
      // 사용자가 더블 클릭을 비활성화하면，아무것도하지 마라.
      if (this.disableDBClick) {
        return
      }
      // 사용자가 강조해야하는 항목-->현재 클릭 된 노드 만 기록하십시오.
      if (this.currentHighlight) {
        nodeClicked = this.model.id
      }
      if (!this.isFolder) {
        this.$set(this.model, 'children', [])
        this.addChild()
        this.open = true
        this.isClicked = true
      }
    },
    mouseOver (e) {
      this.isHover = true
    },
    mouseOut (e) {
      this.isHover = false
    },
    addChild () {
      this.model.children.push({
        name: this.defaultText,
        id: id++
      })
    },
    removeChild (id) {
      // 부모 컴포넌트를 가저온다model.children
      let parentModelChildren = this.$parent.model.children

      // 부모 컴포넌트model.children삭제
      for (let index in parentModelChildren) {
        // 삭제 된 항목 찾기id
        if (parentModelChildren[index].id === id) {
          parentModelChildren = parentModelChildren.splice(index, 1)
          break
        }
      }
    },
    drag (e) {
      fromData = this
      rootTree.emitDrag(this.model, this, e)
    },
    dragStart (e) {
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('text/plain', 'asdad')
      return true
    },
    dragOver (e) {
      e.preventDefault()
      rootTree.emitDragOver(this.model, this, e)
      return true
    },
    dragEnter (e) {
      if (this._uid !== fromData._uid) {
        this.styleObj.opacity = 0.5
      }
      console.log('===', this.model.name)
      rootTree.emitDragEnter(this.model, this, e)
    },
    dragLeave (e) {
      this.styleObj.opacity = 1
      rootTree.emitDragLeave(this.model, this, e)
    },
    drop (e) {
      e.preventDefault()
      this.styleObj.opacity = 1
      // 현재 노드가 존재하지 않는다고 판단하면drop，return;
      if (!this.allowDrop(this.model, this)) {
        return
      }
      toData = this
      console.log('===', fromData.model.name, '---->', toData.model.name)

      exchangeData(rootTree, fromData, toData)
      rootTree.emitDrop(this.model, this, e)
    },
    dragEnd (e) {
      rootTree.emitDragEnd(this.model, this, e)
    }
  },
  created () {
    rootTree = findRoot(this)
  }
}
</script>

<style>
.dnd-container {
  background: #ddd;
}

.dnd-container .is-clicked {
  background: #e5e9f2;
}

.dnd-container .is-hover {
  background: #e5e9f2;
}

.item {
  cursor: pointer;
}

.bold {
  font-weight: bold;
}

.text {
  font-size: 12px;
}

.treeNodeText {
  height: 28px;
  box-sizing: border-box;
  width: fit-content;
  font-size: 18px;
  color: #324057;
  display: flex;
  align-items: center;
}

.changeTree {
  width: 16px;
  color: #324057;
}

.vue-drag-node-icon {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 10px;
  margin-right: 8px;
  border-left: 4px solid grey;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-right: 0 solid yellow;
  transition: transform 0.3s ease-in-out;
}

.nodeClicked {
  transform: rotate(90deg);
}
</style>

